var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile_1_",
    "data-name": "profile (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.3,
    height: 20.001,
    viewBox: "0 0 19.3 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46940",
    "data-name": "Group 46940",
    transform: "translate(3.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54363",
    "data-name": "Path 54363",
    d: "M8.167,8.333a4.167,4.167,0,1,1,4.167-4.167A4.171,4.171,0,0,1,8.167,8.333Zm0-7.5A3.333,3.333,0,1,0,11.5,4.167,3.337,3.337,0,0,0,8.167.833Z",
    transform: "translate(-4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46941",
    "data-name": "Group 46941",
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54364",
    "data-name": "Path 54364",
    d: "M7.083,19.5H.417A.417.417,0,0,1,0,19.083V15.75A3.755,3.755,0,0,1,3.75,12h5a.417.417,0,0,1,0,.833h-5A2.92,2.92,0,0,0,.833,15.75v2.917h6.25a.417.417,0,1,1,0,.833Z",
    transform: "translate(0 -12)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46944",
    "data-name": "Group 46944",
    transform: "translate(9.032 9.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46942",
    "data-name": "Group 46942",
    transform: "translate(3.052 3.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54365",
    "data-name": "Path 54365",
    d: "M16.583,19.167a2.083,2.083,0,1,1,2.083-2.083A2.086,2.086,0,0,1,16.583,19.167Zm0-3.333a1.25,1.25,0,1,0,1.25,1.25A1.252,1.252,0,0,0,16.583,15.833Z",
    transform: "translate(-14.5 -15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46943",
    "data-name": "Group 46943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54366",
    "data-name": "Path 54366",
    d: "M16.637,21.833H15.308a.83.83,0,0,1-.829-.751l-.106-1.059a3.913,3.913,0,0,1-.721-.419l-.973.439a.829.829,0,0,1-1.064-.343l-.664-1.151a.831.831,0,0,1,.235-1.093l.858-.617a3.164,3.164,0,0,1,0-.845l-.858-.617a.831.831,0,0,1-.235-1.093l.664-1.151a.83.83,0,0,1,1.064-.343l.973.439a3.913,3.913,0,0,1,.721-.419l.106-1.059a.83.83,0,0,1,.829-.75h1.329a.83.83,0,0,1,.829.751l.106,1.059a3.906,3.906,0,0,1,.721.419l.973-.439a.832.832,0,0,1,1.064.343l.664,1.151a.831.831,0,0,1-.235,1.093L19.9,16a3.164,3.164,0,0,1,0,.845l.857.617a.831.831,0,0,1,.235,1.093l-.663,1.15a.83.83,0,0,1-1.064.343l-.973-.439a3.913,3.913,0,0,1-.721.419l-.107,1.06a.83.83,0,0,1-.829.75ZM13.711,18.7a.417.417,0,0,1,.267.1,3.1,3.1,0,0,0,.927.539.417.417,0,0,1,.272.35L15.309,21h1.329l.131-1.309a.417.417,0,0,1,.272-.35,3.121,3.121,0,0,0,.927-.539.416.416,0,0,1,.438-.06l1.2.543.664-1.151-1.065-.765a.419.419,0,0,1-.167-.411,2.639,2.639,0,0,0,0-1.08.418.418,0,0,1,.167-.411l1.065-.765-.664-1.151-1.2.543a.417.417,0,0,1-.439-.06,3.073,3.073,0,0,0-.927-.539.417.417,0,0,1-.272-.35l-.131-1.312H15.308l-.131,1.309a.417.417,0,0,1-.272.35,3.121,3.121,0,0,0-.927.539.414.414,0,0,1-.438.06l-1.2-.543L11.672,14.7l1.065.765a.419.419,0,0,1,.167.411,2.639,2.639,0,0,0,0,1.08.418.418,0,0,1-.167.411l-1.065.765.664,1.151,1.2-.542a.435.435,0,0,1,.171-.035Z",
    transform: "translate(-10.838 -11.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownSettings);
export default __webpack_public_path__ + "static/media/profiledropdown-settings.a8dda4cc12aaeace5772fa7d46c5744c.svg";
export { ForwardRef as ReactComponent };